<template>
  <TheMenuLayout>
    <BaseSectionHeader>
      Envoi de document
    </BaseSectionHeader>
    <BaseFileUploader
      @change="documentsToUpload = $event"
      label="Cliquez ici pour ajouter un document"
      class="mb-4"
    />
    <BaseButton
      block
      color="primary"
      @click="uploadDocuments"
      class="mb-8"
      :disabled="!documentsToUpload.length"
    >
      Envoyer
    </BaseButton>

    <BaseSectionHeader class="mb-4">
      Mes documents envoyés
    </BaseSectionHeader>

    <BaseList :items="formattedDocuments" />
  </TheMenuLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import humanFileSize from '@/humanFileSize';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import BaseFileUploader from '@/components/BaseFileUploader.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseList from '@/components/BaseList.vue';

export default {
  name: 'DocumentUpload',
  components: {
    TheMenuLayout,
    BaseSectionHeader,
    BaseFileUploader,
    BaseButton,
    BaseList,
  },
  created() {
    this.fetchUploadedDocuments();
  },
  data() {
    return {
      documentsToUpload: [],
    };
  },
  methods: {
    uploadDocuments() {
      this.sendDocuments(this.documentsToUpload);
    },
    ...mapActions(['fetchUploadedDocuments', 'sendDocuments']),
  },
  computed: {
    ...mapState(['uploadedDocuments']),
    formattedDocuments() {
      return this.uploadedDocuments.map((doc, index) => (
        {
          key: 100 + index,
          title: doc.name,
          icon: 'mdi-file',
          href: doc.url,
          subtitles: [
            {
              name: 'Taille',
              description: humanFileSize(doc.size),
            },
            {
              name: 'Type',
              description: doc.content_type,
            },
          ],
        }
      ));
    },
  },
};
</script>
